import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SingularPluralPipe} from '@wba/commons/pipes/singular-plural.pipe';
import {FocusDirective} from '@wba/commons/directives/focus.directive';
import {CommonTranslationModule} from '@wba/commons/modules/translation.module/translation.module';
import {MomentDatePipe} from '@wba/commons/pipes/moment-date.pipe';
import {AntragSpaeterFortsetzenComponent} from '@wba/commons/components/antrag-spaeter-fortsetzen/antrag-spaeter-fortsetzen.component';
import {UploadedFilePipe} from '@wba/commons/pipes/uploaded-file.pipe';
import {WbaUiModule} from '@wba/commons/modules/wba-ui.module/wba-ui.module';
import {NameUndGeburtsdatumPipe} from '@wba/commons/pipes/name-und-geburtsdatum.pipe';
import {PiwikModule} from '@wba/commons/modules/piwik';
import {DokumentSchwaerzenDialogComponent} from '@wba/commons/components/dokument-schwaerzen-dialog/dokument-schwaerzen-dialog.component';
import {SelectItemPipe} from '@wba/commons/pipes/select-item.pipe';
import {FormLoeschenButtonLeisteComponent} from '@wba/commons/components/form-loeschen-button-leiste/form-loeschen-button-leiste.component';
import {DebuggingMenuComponent} from '@wba/commons/components/debugging-menu/debugging-menu.component';


@NgModule({
  imports: [
    CommonModule,
    WbaUiModule,
    CommonTranslationModule,
    PiwikModule
  ],
  declarations: [
    SingularPluralPipe,
    MomentDatePipe,
    UploadedFilePipe,
    SelectItemPipe,
    FocusDirective,
    NameUndGeburtsdatumPipe,
    AntragSpaeterFortsetzenComponent,
    FormLoeschenButtonLeisteComponent,
    DokumentSchwaerzenDialogComponent,
    DebuggingMenuComponent
  ],
  exports: [
    CommonModule,
    CommonTranslationModule,
    WbaUiModule,
    PiwikModule,
    SingularPluralPipe,
    MomentDatePipe,
    UploadedFilePipe,
    FormLoeschenButtonLeisteComponent,
    NameUndGeburtsdatumPipe,
    FocusDirective,
    AntragSpaeterFortsetzenComponent,
    DokumentSchwaerzenDialogComponent,
    DebuggingMenuComponent,
    SelectItemPipe
  ]
})
export class SharedModule {
}
